import React from "react";
import { AuthGuard } from "../components/auth/AuthGuard";

const PageWrapper = ({ children }) => {
  return (
    <>
      <AuthGuard>{children}</AuthGuard>
    </>
  );
};

export default PageWrapper;
